import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "../services/auth.service";
import TopBar from "../components/TopBar";
import WeightDetail from "../components/WeightDetail";

function Weight() {
  const navigate = useNavigate();
  const { calfId, id } = useParams();
  const back = "/veaux/" + calfId + "?view=weights";

  useEffect(() => {
    if (!AuthService.getCurrentUser()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div>
      <TopBar link={back}></TopBar>
      <div className="flex flex-col">
        <div className="mx-3 mb-3">
          <span className="text-2xl font-bold text-stone-700 dark:text-slate-100">
            Détail de la pesée
          </span>
        </div>
        <WeightDetail weightId={id} onDeleted={() => navigate(back)} />
      </div>
    </div>
  );
}

export default Weight;
